<template>
  <b-card title="User Matters" class="m-0 p-0" no-body>
    <matter-list :id="id" />
  </b-card>
</template>

<script>
import { BCard, BImg, BMedia, BAvatar } from 'bootstrap-vue'
import MatterList from './matter-list/MatterList.vue'

export default {
  components: {
    BCard,
    BImg,
    BMedia,
    BAvatar,
    MatterList
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
        id: this.userId
    }
  }
}
</script>

<style></style>
